<template>

  <v-card class="dashboardcontent">
    <v-card-actions>  
    <v-btn      
      icon
      :to="'/'+$home+'content/device'"
      >      
      <v-icon>mdi-table-of-contents</v-icon>
    </v-btn>
    </v-card-actions>    

  <v-list-item two-line>
      <v-list-item-icon
        class="dash-icon"
        >
        <v-icon
          size="24"          
          >mdi-tools</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title class="d-title">
          Geräte/Equipment
        </v-list-item-title>        
      </v-list-item-content>
    </v-list-item>

  <v-data-table
      v-model="selected"
      :headers="headers"
      :items="devices"
      :footer-props="{
        'disable-items-per-page': true        
      }"      
      :items-per-page="5"
      :single-select="singleSelect"
      :search="search"
      item-key="id"
      class="elevation-1 list-blank"
    >

    <template v-slot:body="{ items }">
      <tbody>
        <tr
          v-for="(item) in items"
          :key="item.id"
        >
          <td>{{ item.id }}</td>
          <td>
            <router-link :to="'/'+$home+'node/device/' + item.id" text small>
            {{ item.name }}
            </router-link>
          </td>                                             
          <td>
            {{ item.manufacturer }}
          </td>
        </tr>
      </tbody>
    </template>

  </v-data-table>

  </v-card>
</template>

<script>

//import UserContent from '../../helper/UserContent.js';

export default {
  name: 'DashboardDevices',  
  props: ['type'],
  data () {
    return {
      singleSelect: false,
      selected: [],
      search: '',
      headers: [
        { text: 'ID',
          align: 'start',
          value: 'id',
          sortable: false
        },
        {
          text: 'Name',
          value: 'name',
        },
        {
          text: 'Hersteller',
          value: 'manufacturer',
          width: '40%'      
        }
      ],
      devices: [],
      overlaydata: null
    }
  },
  methods: {
      getDevices() {          
          this.axios.get( this.$config.host+"/devices" ).then(response => (
            this.devices = response.data
          ));          
      }
  },
  mounted() {        
    //console.log("mounted Dash devices");
    this.getDevices();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
